// Helper to determine the API URL based on environment
const getApiUrl = (endpoint) => {
  // Check if running locally
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    // Assuming default Firebase Emulator port 5001 and project ID 'data-sculpture'
    // You might need to adjust the project ID if it differs
    return `http://127.0.0.1:5001/data-sculpture/us-central1/${endpoint}`;
  }
  // Production URL
  return `https://us-central1-data-sculpture.cloudfunctions.net/${endpoint}`;
};

export const sendCollaboratorInviteEmail = async (data) => {
  try {
    const response = await fetch(getApiUrl("sendCollaboratorInviteEmail"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // Firebase onRequest functions expect body.data when using the pattern in index.js
      body: JSON.stringify({ data }),
    });

    const result = await response.json();
    
    if (!response.ok) {
      return { success: false, error: result.error || "Failed to send email" };
    }

    return { success: true, ...result };
  } catch (error) {
    console.error("Error sending collaborator invite email:", error);
    return { success: false, error: error.message };
  }
};

export const sendWelcomeEmail = async (email, firstName) => {
  try {
    const response = await fetch(getApiUrl("sendWelcomeEmail"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ 
        data: { email, firstName } 
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      return { success: false, error: result.error || "Failed to send email" };
    }

    return { success: true, ...result };
  } catch (error) {
    console.error("Error sending welcome email:", error);
    return { success: false, error: error.message };
  }
};